<template lang="pug">
  div.environment-dashboard(:class='{ haveWS: visibleWS }')
    transition(name='slide-fade-down' mode='out-in' appear)
      MapToolsGeneric(ref='toolsGeneric' verticalType="meteo" @updateFilter='updateFilter')
    transition(name='fade')
      LegendMap(:verticalType='tabsVertical' :dataLengend='listMeteo[tabsVertical].legend' :datosFinal='dataParkingPanels2' :dataParkingCurrent='dataParkingCurrent' ref="legendMap")
    transition(name='fadeSlide' appear)
      PanelDashboard
        VerticalGeneric(
          slot="container"
          ref='verticalGeneric'
          @updateKpiGeneric='updateKpiGeneric'
          @setPopupParking='setPopupParking'
          verticalType='meteo')
        MapZoomParks.panel-dashboard__tools.panel-dashboard__tools--bottom-left-out(
          slot="tools"
          ref='mapZoom'
          )
          // WebSocket(@showAlerts='showAlerts' @visible='visible')
        SearchMap.panel-dashboard__search.panel-dashboard__search--top-left-out(
          slot="search"
          ref="mapSearch"
        )
</template>

<script>

import VerticalGeneric from '@/views/VerticalGeneric'
import PanelDashboard from '@/components/PanelDashboard'
import MapZoomParks from '@/components/MapZoomParks'
import MapToolsGeneric from '@/components/MapToolsGeneric'
import SearchMap from '@/components/SearchMap'
import LegendMap from '@/components/LegendMap'

// import WebSocket from '@/components/WebSocket'
import mapChartsElements from '@/mixins/mapChartsElements'

import jsonGisMeteorologia from '@/moks/las_palmas/environment/gisMeteorologia'
import jsonGisCalidadDelAire from '@/moks/las_palmas/environment/gisCalidadDelAire'
import jsonGisAlergenos from '@/moks/las_palmas/environment/gisAlergenos'
import jsonGisNoiseLevel from '@/moks/las_palmas/environment/gisNoiseLevel'

export default {
  name: 'EnvironmentDashboard',
  data () {
    return {
      opened: false,
      visibleWS: false,
      mapLoad: false,
      dataTemperature: null,
      dataAeroAllergen: null,
      dataAirQuality: null,
      dataTheNoise: null,
      tabsVertical: 'Meteorology',
      listMeteo: {
        Meteorology: {
          name: 'Medioambiente',
          value: 'Medioambiente',
          label: 'Medioambiente',
          breadcumb: 'Medioambiente',
          listCategory: [
            {
              value: 'dataSourceWeather',
              label: 'Meteorology',
              show: true
            },
            {
              value: 'dataSourceAirQuality',
              label: 'AirQuality',
              show: true
            },
            {
              value: 'dataSourceAeroAllergen',
              label: 'Allergens',
              show: true
            },
            {
              value: 'dataSourceNoiseLevel',
              label: 'NoiseLevel',
              show: true
            }
          ],
          listCategorySelected: ['dataSourceWeather', 'dataSourceAirQuality', 'dataSourceAeroAllergen', 'dataSourceNoiseLevel'],
          legend: [
            {
              label: 'Meteorología',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_weather_green.svg',
              type: 'point'
            },
            {
              label: 'Calidad del aire',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_airQuality_blue.svg',
              type: 'point'
            },
            {
              label: 'Alérgenos',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_allergen_violet.svg',
              type: 'point'
            },
            {
              label: 'Nivel de ruido',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_noise_pink.svg',
              type: 'point'
            }
          ]
        }
      },
      dataParkingPanels2: {},
      dataParkingCurrent: {}
    }
  },
  mixins: [mapChartsElements],
  methods: {
    cleanAndLoadDataGis () {
      const component = this
      var category = []
      var categorySelected = []
      var myLoadMap = () => {
        if (component.mapLoad === true && component.$refs.toolsGeneric !== undefined) {
          document.getElementById('dataIframe').contentWindow.mapClear()
          category = component.listMeteo[component.tabsVertical].listCategory
          categorySelected = component.listMeteo[component.tabsVertical].listCategorySelected
          component.$refs.toolsGeneric.setToolsGeneric(
            category,
            categorySelected
          )
          component.loadDataFilter()
          component.$refs.verticalGeneric.updateKpis(categorySelected, component.tabsVertical)
          clearInterval(myLoadMapElem)
        }
      }
      var myLoadMapElem = setInterval(myLoadMap, 500)
    },
    loadDataFilter () {
      document.getElementById('dataIframe').contentWindow.activarDesactivarCapa(this.listMeteo[this.tabsVertical].listCategory)
    },
    updateKpiGeneric () {
      const component = this
      // var category, categorySelected
      let categorySelected
      // category = component.$refs.toolsGeneric.getDataCategory()
      categorySelected = component.$refs.toolsGeneric.getCaterogySelected()
      component.$refs.verticalGeneric.updateKpis(categorySelected, this.tabsVertical)
    },
    updateFilter (category, categorySelected) {
      this.$refs.verticalGeneric.updateKpis(category, this.tabsVertical)
    },
    init () {
      const vm = this
      var myLoadMap = () => {
        let encontrado = false
        if (vm.mapLoad === true) {
          document.getElementById('dataIframe').contentWindow.mapClear()
          let selectArray = vm.listMeteo[vm.tabsVertical].listCategory
          selectArray.forEach(elem => {
            // 'dataSourceSensorZones', 'dataSourceParking', 'dataSourcePanelParking'
            document.getElementById('dataIframe').contentWindow.viewer.dataSources._dataSources
              .filter((data) => data._name.name === elem.value)
              .map((valor) => {
                valor.show = true
                encontrado = true
                return valor
              })
          })
          if (!encontrado) {
            vm.myTimerTemperature()
            vm.myTimerAirQuality()
            vm.myTimerAeroAllergen()
            vm.myTimerNoiseLevel()
          }
          vm.controlPage()
          clearInterval(myLoadMapElem)
        }
      }
      var myLoadMapElem = setInterval(myLoadMap, 500)
    },
    showAlerts (data, category) {
      // this.$emit('showAlerts', data, 'medioambiente')
      document
        .getElementById('dataIframe')
        .contentWindow.showAlerts(data, 'medioambiente')
    },
    showAlertMap (data, category) {
      this.$emit('showAlertMap', data, 'medioambiente')
    },
    visible (data) {
      this.visibleWS = data
    },
    controlPage () {
      const component = this
      component.cleanAndLoadDataGis()
    },
    myTimerTemperature () {
      // const component = this
      let simb = 'img/icon_weather_green.svg'
      let simbSelected = 'img/icon_weather_white.svg'
      let simbIsolated = 'ods-icon-icon_weather_isolated'
      /** Se generan las entidades de tipo punto de los termómetros */
      document
        .getElementById('dataIframe')
        .contentWindow.createLayer(
          jsonGisMeteorologia,
          'medioambiente',
          'point',
          'entity',
          'billboard',
          simb,
          simbSelected,
          simbIsolated,
          0.8
        )
      /** Este elemento aparece cargado inicialmente */
    },
    myTimerAirQuality () {
      // const component = this
      let simb = 'img/icon_airQuality_blue.svg'
      let simbSelected = 'img/icon_airQuality_white.svg'
      let simbIsolated = 'ods-icon-icon_airQuality_isolated'
      /** Se generan las entidades de tipo punto de los medidores de la calidad
       * del aire */
      document
        .getElementById('dataIframe')
        .contentWindow.createLayer(
          jsonGisCalidadDelAire,
          'medioambiente',
          'point',
          'entity',
          'billboard',
          simb,
          simbSelected,
          simbIsolated,
          0.8
        )
    },
    myTimerAeroAllergen () {
      // const component = this
      let simb = 'img/icon_allergen_violet.svg'
      let simbSelected = 'img/icon_allergen_white.svg'
      let simbIsolated = 'ods-icon-icon_allergen_isolated'
      /** Se generan las entidades de tipo punto de los medidores de la calidad
       * del aire */
      document
        .getElementById('dataIframe')
        .contentWindow.createLayer(
          jsonGisAlergenos,
          'medioambiente',
          'point',
          'entity',
          'billboard',
          simb,
          simbSelected,
          simbIsolated,
          0.8
        )
    },
    myTimerNoiseLevel () {
      // const component = this
      let simb = 'img/icon_noise_pink.svg'
      let simbSelected = 'img/icon_noise_white.svg'
      let simbIsolated = 'ods-icon-icon_noise_isolated'
      /** Se generan las entidades de tipo punto de los medidores de la calidad
       * del aire */
      document
        .getElementById('dataIframe')
        .contentWindow.createLayer(
          jsonGisNoiseLevel,
          'medioambiente',
          'point',
          'entity',
          'billboard',
          simb,
          simbSelected,
          simbIsolated,
          0.8
        )
    },
    setMapLoad () {
      this.mapLoad = true
      // console.log(this.$refs.mapSearch.changeBasemap())
    },
    setPopupParking (val, data, type, currentKpi) {
      this.$refs.legendMap.open = this.$refs.legendMap.data = true
      this.openedParking = val
      this.dataParkingPanels = []
      this.dataParkingPanels = data
      this.dataParkingPanels2 = data
      this.dataParkingCurrent = currentKpi
    }
  },
  components: {
    PanelDashboard,
    VerticalGeneric,
    MapZoomParks,
    MapToolsGeneric,
    SearchMap,
    LegendMap
    // WebSocket
  },
  created () {
    // this.$store.dispatch('getAllStations')
    this.$emit('controlLoad')
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.haveWS {
  .panel-dashboard__tools--bottom-left-out {
    bottom: 61px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/EnvironmentDashboard.vue